import React, { useState, useEffect } from "react";
import {
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  FormGroup,
  Form,
  Alert,
  Spinner,
} from "reactstrap";
import { Table, Button } from "reactstrap";
import * as FaIcons from "react-icons/fa";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import "jspdf-autotable";
import logos from "../../components/img/base/111.png";
import axios from "axios";
import "../Bec/bec.scss";
import Swal from "sweetalert2";

function ListUserGrad() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [modalInsertar, setModalInsertar] = useState(false);
  const [modalEditar, setModalEditar] = useState(false);
  const [modalEliminar, setModalEliminar] = useState(false);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState({
    nombre: "",
    apellido: "",
    email: "",
    carr_sup_bec: "",
    inst_sup_bec: "",
    tipcarr_sup_bec: "",
    anio_ing_bqef: "",
    anio_egre_bqef: "",
    igle_nac_bec: "",
    jmen_bec: "",
    celular: "",
    patro_bec: "",
  });

  const [allData, setAllData] = useState([]); // Datos originales sin filtrar
  // Estado para búsqueda
  const [busqueda, setBusqueda] = useState("");

  // Estado para ordenamiento
  const [sortField, setSortField] = useState(null);
  const [order, setOrder] = useState("asc");
  // Definir un objeto de validación con patrones de expresiones regulares y estados de validación iniciales
  const validation = {
    nombre: { regex: /^[a-zA-ZÀ-ÿ\s]{1,20}$/, isValid: true },
    apellido: { regex: /^[a-zA-ZÀ-ÿ\s]{1,20}$/, isValid: true },
    email: {
      regex:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      isValid: false,
    },
    carr_sup_bec: {
      regex:
        /^[a-zA-Z0-9\s.,-ñÑáéíóúÁÉÍÓÚüÜ#°ºª!@#$%&*()_+=[\]{};':"\\|,.<>?]{1,100}$/,
      isValid: true,
    },
    inst_sup_bec: {
      regex:
        /^[a-zA-Z0-9\s.,-ñÑáéíóúÁÉÍÓÚüÜ#°ºª!@#$%&*()_+=[\]{};':"\\|,.<>?]{1,100}$/,
      isValid: true,
    },
    igle_nac_bec: {
      regex:
        /^[a-zA-Z0-9\s.,-ñÑáéíóúÁÉÍÓÚüÜ#°ºª!@#$%&*()_+=[\]{};':"\\|,.<>?]{1,100}$/,
      isValid: true,
    },
    jmen_bec: {
      regex:
        /^[a-zA-Z0-9\s.,-ñÑáéíóúÁÉÍÓÚüÜ#°ºª!@#$%&*()_+=[\]{};':"\\|,.<>?]{1,100}$/,
      isValid: true,
    },
    celular: { regex: /^\d{8,8}$/, isValid: true },
    patro_bec: {
      regex:
        /^[a-zA-Z0-9\s.,-ñÑáéíóúÁÉÍÓÚüÜ#°ºª!@#$%&*()_+=[\]{};':"\\|,.<>?]{1,100}$/,
      isValid: true,
    },
  };

  const [isValid, setIsValid] = useState({
    nombre: false,
    apellido: false,
    email: false,
    carr_sup_bec: false,
    inst_sup_bec: false,
    igle_nac_bec: false,
    jmen_bec: false,
    celular: false,
    patro_bec: false,
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUsuarioSeleccionado((prevState) => ({ ...prevState, [name]: value }));

    if (validation[name]) {
      const isValidValue = validation[name].regex.test(value);
      setIsValid((prevState) => ({ ...prevState, [name]: isValidValue }));
    } else {
      // Opcional: si no quieres validar ciertos campos
      // Puedes establecer isValid para esos campos en true o false según corresponda
    }
  };

  const abrirCerrarModalInsertar = () => {
    setModalInsertar(!modalInsertar);
  };

  const abrirCerrarModalEditar = () => {
    setModalEditar(!modalEditar);
  };

  const abrirCerrarModalEliminar = () => {
    setModalEliminar(!modalEliminar);
  };
  const baseUrl = "https://bqef-bo.com/api/A/apiDash.php";
  // const baseUrlE = "https://bqef-bo.com/api/A/importar_excel.php";
  ////Datos usuario Administrador
  const [dataAdm, setDataAdm] = useState({});
  const peticionGetAdm = async () => {
    setLoading(true);
    setError("");
    const adminId = sessionStorage.getItem("iduser");
    try {
      const res = await axios.get(`${baseUrl}?action=getInfoAdm&id=${adminId}`);
      const receivedData =
        res.data.InfoAdm && Array.isArray(res.data.InfoAdm)
          ? res.data.InfoAdm
          : [];
      // console.log(res.data);
      setDataAdm(receivedData);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ha ocurrido un error al cargar los datos.",
        footer: `Código de error: ${error.response.status}`,
      });
    }
  };
  /////Listado becario graduado
  const [data, setData] = useState([]);
  const peticionGet = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${baseUrl}?action=getGrad`);
      const receivedData =
        res.data.bec_graduados && Array.isArray(res.data.bec_graduados)
          ? res.data.bec_graduados
          : [];
      // console.log(receivedData);
      setAllData(receivedData);
      setData(receivedData);
    } catch (error) {
      console.error(error);
      setError("Error al cargar los datos");
    } finally {
      setLoading(false);
    }
  };
  /////Crear Usuario Becario Graduado
  async function peticionPost(e) {
    e.preventDefault();
    let fd = new FormData();
    fd.append("nombre", usuarioSeleccionado.nombre);
    fd.append("apellido", usuarioSeleccionado.apellido);
    fd.append("email", usuarioSeleccionado.email);
    fd.append("carr_sup_bec", usuarioSeleccionado.carr_sup_bec);
    fd.append("inst_sup_bec", usuarioSeleccionado.inst_sup_bec);
    fd.append("tipcarr_sup_bec", usuarioSeleccionado.tipcarr_sup_bec);
    fd.append("anio_ing_bqef", usuarioSeleccionado.anio_ing_bqef);
    fd.append("anio_egre_bqef", usuarioSeleccionado.anio_egre_bqef);
    fd.append("igle_nac_bec", usuarioSeleccionado.igle_nac_bec);
    fd.append("jmen_bec", usuarioSeleccionado.jmen_bec);
    fd.append("celular", usuarioSeleccionado.celular);
    fd.append("patro_bec", usuarioSeleccionado.patro_bec);

    // Acceder directamente a la primera posición del array
    if (Array.isArray(dataAdm) && dataAdm.length > 0 && dataAdm[0].id_adm) {
      const idAdm = dataAdm[0].id_adm;
      fd.append("usu_creacion", idAdm);
    } else {
      console.error("No se encontró id_adm");
      return; // Detener envío si no hay id_adm
    }

    try {
      // const res =
      await axios.post(`${baseUrl}?action=addGrad`, fd);
      // console.log(res.data);
      mostrarAlertaN();
      peticionGet();
      abrirCerrarModalInsertar();
    } catch (error) {
      console.log(error.response.data);
      mostrarAlertaError();
    }
  }
  /////Modificar Usuario patrocinador
  const peticionPut = async () => {
    // Verifica que dataAdm tiene datos
    const idAdm =
      Array.isArray(dataAdm) && dataAdm.length > 0 ? dataAdm[0].id_adm : null;

    if (!idAdm) {
      console.error("No se encontró id_adm para modificar");
      return; // O maneja el error de otra forma
    }

    const dataToSend = {
      nombre: usuarioSeleccionado.nombre,
      apellido: usuarioSeleccionado.apellido,
      email: usuarioSeleccionado.email,
      carr_sup_bec: usuarioSeleccionado.carr_sup_bec,
      inst_sup_bec: usuarioSeleccionado.inst_sup_bec,
      tipcarr_sup_bec: usuarioSeleccionado.tipcarr_sup_bec,
      anio_ing_bqef: usuarioSeleccionado.anio_ing_bqef,
      anio_egre_bqef: usuarioSeleccionado.anio_egre_bqef,
      igle_nac_bec: usuarioSeleccionado.igle_nac_bec,
      jmen_bec: usuarioSeleccionado.jmen_bec,
      celular: usuarioSeleccionado.celular,
      patro_bec: usuarioSeleccionado.patro_bec,
      usu_modificacion: idAdm,
    };
    console.log("email:", usuarioSeleccionado.email);
    console.log("Datos a enviar:", dataToSend);
    try {
      await axios.put(
        `${baseUrl}?action=updateGrad&email=${encodeURIComponent(
          usuarioSeleccionado.email
        )}`,
        dataToSend,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // Después de la solicitud exitosa, actualizar el estado local
      const dataNueva = [...data];
      dataNueva.forEach((Usuario) => {
        if (Usuario.email === usuarioSeleccionado.email) {
          Usuario.nombre = usuarioSeleccionado.nombre;
          Usuario.apellido = usuarioSeleccionado.apellido;
          Usuario.carr_sup_bec = usuarioSeleccionado.carr_sup_bec;
          Usuario.inst_sup_bec = usuarioSeleccionado.inst_sup_bec;
          Usuario.tipcarr_sup_bec = usuarioSeleccionado.tipcarr_sup_bec;
          Usuario.anio_ing_bqef = usuarioSeleccionado.anio_ing_bqef;
          Usuario.anio_egre_bqef = usuarioSeleccionado.anio_egre_bqef;
          Usuario.igle_nac_bec = usuarioSeleccionado.igle_nac_bec;
          Usuario.jmen_bec = usuarioSeleccionado.jmen_bec;
          Usuario.celular = usuarioSeleccionado.celular;
          Usuario.patro_bec = usuarioSeleccionado.patro_bec;
        }
      });
      setData(dataNueva);
      abrirCerrarModalEditar();
      mostrarAlertaU();
    } catch (error) {
      console.error("Error en peticionPut:", error);
    }
  };
  /////Eliminar Usuario Becario Graduado
  async function peticionDelete(email) {
    const idAdm =
      Array.isArray(dataAdm) && dataAdm.length > 0 ? dataAdm[0].id_adm : null;

    if (!idAdm) {
      console.error("No se encontró id_adm para eliminar");
      return;
    }

    try {
      // const res =
      await axios.delete(
        `${baseUrl}?action=deleteGrad&email=${encodeURIComponent(
          email
        )}&usu_modificacion=${idAdm}`
      );
      // console.log("Respuesta del servidor:", res.data);
      abrirCerrarModalEliminar();
      peticionGet();
      mostrarAlertaD();
    } catch (error) {
      console.error("Error en eliminación:", error);
    }
  }

  const seleccionarUsuario = (Usuario, caso) => {
    setUsuarioSeleccionado(Usuario);

    caso === "Editar" ? abrirCerrarModalEditar() : abrirCerrarModalEliminar();
  };

  useEffect(() => {
    peticionGet();
    peticionGetAdm();
  }, []);

  // Manejar cambio en barra de búsqueda
  const handleChangeB = (e) => {
    const valor = e.target.value;
    setBusqueda(valor);
    filtrar(valor);
  };

  // Filtrar datos
  const filtrar = (terminoBusqueda) => {
    const lowerCaseTerm = terminoBusqueda.toLowerCase();
    const resultadosBusqueda = allData.filter((elemento) => {
      const {
        nombre,
        apellido,
        email,
        tipcarr_sup_bec,
        anio_ing_bqef,
        anio_egre_bqef,
        igle_nac_bec,
        jmen_bec,
        celular,
        patro_bec,
      } = elemento;
      return (
        (nombre && nombre.toLowerCase().includes(lowerCaseTerm)) ||
        (apellido && apellido.toLowerCase().includes(lowerCaseTerm)) ||
        (email && email.toLowerCase().includes(lowerCaseTerm)) ||
        (tipcarr_sup_bec &&
          tipcarr_sup_bec.toLowerCase().includes(lowerCaseTerm)) ||
        (anio_ing_bqef &&
          anio_ing_bqef.toString().toLowerCase().includes(lowerCaseTerm)) ||
        (anio_egre_bqef &&
          anio_egre_bqef.toString().toLowerCase().includes(lowerCaseTerm)) ||
        (igle_nac_bec &&
          igle_nac_bec.toString().toLowerCase().includes(lowerCaseTerm)) ||
        (jmen_bec &&
          jmen_bec.toString().toLowerCase().includes(lowerCaseTerm)) ||
        (celular && celular.toString().toLowerCase().includes(lowerCaseTerm)) ||
        (patro_bec &&
          patro_bec.toString().toLowerCase().includes(lowerCaseTerm))
      );
    });
    setData(resultadosBusqueda);
  };

  // Ordenar datos
  const handleSortingChange = (accessor) => {
    const isSameField = accessor === sortField;
    const sortOrder = isSameField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);

    // Crear una copia de los datos antes de ordenar para no mutar el estado
    const sortedArray = [...data].sort((a, b) => {
      const aVal = a[accessor];
      const bVal = b[accessor];

      if (aVal == null) return 1; // Para manejar valores nulos o undefined
      if (bVal == null) return -1;

      if (aVal < bVal) return sortOrder === "asc" ? -1 : 1;
      if (aVal > bVal) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });

    setData(sortedArray);
  };
  ////ALERTAS
  const mostrarAlertaN = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Nuevo usuario registrado correctamente.",
      timer: 5000,
      icon: "success",
    });
  };
  const mostrarAlertaU = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Usuario Modificado.",
      timer: 5000,
      icon: "info",
    });
  };
  const mostrarAlertaD = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Eliminado!",
      text: "Usuario Eliminado.",
      timer: 5000,
      icon: "success",
    });
  };
  const mostrarAlertaError = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Error!",
      text: "No se pudo registrar.",
      timer: 5000,
      icon: "danger",
    });
  };

  const sortedData = data.sort((a, b) => {
    if (a[sortField] < b[sortField]) {
      return order === "asc" ? -1 : 1;
    }
    if (a[sortField] > b[sortField]) {
      return order === "asc" ? 1 : -1;
    }
    return 0;
  });

  ///GENERAR PDF INFORME
  const generatePDF = () => {
    // Crear un nuevo documento PDF en orientación horizontal (landscape)
    const doc = new jsPDF("landscape");

    // Propiedades del documento (puedes incluir título, autor, etc.)
    doc.setProperties({
      title: "Reporte de Becarios Graduados",
      author: "BQEF",
      subject: "Reporte de datos",
      keywords: "becarios graduados, reporte, datos",
      creator: "jsPDF",
    });

    // Agregar logo al documento PDF
    doc.addImage(logos, "PNG", 10, 10, 20, 10);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Agregar título "FONDO DE EDUCACIÓN" al documento PDF
    doc.setFontSize(12);
    const title = "FONDO DE EDUCACION DE CUAQUEROS BOLIVIANOS";
    const titleWidth = doc.getTextWidth(title);
    const x = (doc.internal.pageSize.width - titleWidth) / 2; // Calcular posición X para centrar
    const y = 20; // Posición Y del título

    // Escribir el título
    doc.text(title, x, y);

    // Dibujar la línea subrayando el título
    doc.line(x, y + 1, x + titleWidth, y + 1); // Dibuja la línea

    // Restablecer la fuente a normal
    doc.setFont("helvetica", "normal");

    // Agregar subtítulo "Reporte" al documento PDF
    const subtitle = "Reporte Datos Becarios Graduados";
    const subtitleWidth = doc.getTextWidth(subtitle);
    const subtitleX = (doc.internal.pageSize.width - subtitleWidth) / 2; // Calcular posición X para centrar
    doc.text(subtitle, subtitleX, 30);

    // Agregar fecha al documento PDF
    const fecha = new Date();
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const año = fecha.getFullYear();
    doc.setFontSize(9);
    doc.text(`Fecha: ${dia}/${mes}/${año}`, 10, 25);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Definir el texto "Usuario: "
    const usuarioText = "Usuario: Personal Administrativo";

    // Calcular el ancho del texto
    const usuarioWidth = doc.getTextWidth(usuarioText);

    // Calcular la posición X para alinearlo a la derecha
    const usuarioX = doc.internal.pageSize.width - usuarioWidth - 10; // 10 mm de margen desde el borde derecho

    // Escribir el texto "Usuario:" en la posición calculada
    doc.text(usuarioText, usuarioX, 35);

    // Definir los datos de la tabla
    const userData = data
      .map((iteb) => ({
        nombre: iteb.nombre,
        apellido: iteb.apellido,
        email: iteb.email,
        carr_sup_bec: iteb.carr_sup_bec,
        inst_sup_bec: iteb.inst_sup_bec,
        tipcarr_sup_bec: iteb.tipcarr_sup_bec,
        anio_ing_bqef: iteb.anio_ing_bqef,
        anio_egre_bqef: iteb.anio_egre_bqef,
        igle_nac_bec: iteb.igle_nac_bec,
        jmen_bec: iteb.jmen_bec,
        celular: iteb.celular,
        patro_bec: iteb.patro_bec,
      }))
      .sort((a, b) => a.anio_ing_bqef.localeCompare(b.anio_ing_bqef)) // Ordenar por nombre en orden alfabético ascendente
      .map((iteb, nb) => ({
        it: nb + 1, // Asignar el índice de forma ascendente después de ordenar
        ...iteb, // Desestructurar el resto de las propiedades
      }));

    // Definir las columnas de la tabla
    const columns = [
      { header: "N°", dataKey: "it" },
      { header: "Nombre(s)", dataKey: "nombre" },
      { header: "Apellido(s)", dataKey: "apellido" },
      { header: "Correo", dataKey: "email" },
      { header: "Carrera", dataKey: "carr_sup_bec" },
      { header: "Institución", dataKey: "inst_sup_bec" },
      { header: "Tipo Carrera", dataKey: "tipcarr_sup_bec" },
      { header: "Año Ing.", dataKey: "anio_ing_bqef" },
      { header: "Año Egr.", dataKey: "anio_egre_bqef" },
      { header: "Iglesia", dataKey: "igle_nac_bec" },
      { header: "Junta Men.", dataKey: "jmen_bec" },
      { header: "Celular", dataKey: "celular" },
      { header: "Patrocinador", dataKey: "patro_bec" },
    ];

    // Restablecer la fuente a normal
    doc.setFont("helvetica", "normal");

    // Agregar la tabla al documento PDF
    autoTable(doc, {
      columns: columns,
      body: userData,
      startY: 40,
      margin: { top: 20, bottom: 20 },
      bodyStyles: { fontSize: 8 },
      headStyles: { fontSize: 9, fillColor: [10, 49, 67] },
    });

    // Agregar número de página al documento PDF
    let totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.text(
        `Página ${i} de ${totalPages}`,
        10,
        doc.internal.pageSize.height - 10
      );
    }

    // Convertir el documento PDF a blob
    const pdfBlob = doc.output("blob");

    // Abrir el PDF en una nueva ventana
    const url = URL.createObjectURL(pdfBlob);
    window.open(url, "_blank");
  };

  ////excel
  const [modal, setModal] = useState(false);
  const [file, setFile] = useState(null);

  const toggle = () => setModal(!modal);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleImport = () => {
    if (!file) {
      alert("Por favor, selecciona un archivo CSV");
      return;
    }

    // Validar que sea un CSV (opcional, pero recomendado)
    const allowedExtensions = /(\.csv)$/i;
    if (!allowedExtensions.exec(file.name)) {
      alert("Por favor, selecciona un archivo CSV válido");
      return;
    }

    const formData = new FormData();
    formData.append("excelFile", file); // Mantén "excelFile" (lo cambiamos en el backend)

    axios
      .post("https://bqef-bo.com/api/A/importar_excel.php", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        alert("Archivo importado correctamente");
        toggle(); // Cierra el modal tras importar
        peticionGet();
      })
      .catch((error) => {
        alert(
          "Error al importar el archivo: " + error.response?.data ||
            error.message
        );
        console.error(error);
      });
  };
  ////Carga
  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner color="primary" />
        Cargando...
      </div>
    );
  }

  if (error) {
    return <Alert color="danger">{error}</Alert>;
  }
  return (
    <div id="main_content">
      <div className="tra">
        <div className="tra title-form">
          <h2>Listado Becarios Graduados</h2>
        </div>
        <div className="frm">
          <Button
            color="success"
            size="lg"
            onClick={() => abrirCerrarModalInsertar()}
          >
            <FaIcons.FaPlus /> Añadir
          </Button>
          &nbsp;&nbsp;
          <Button color="primary" size="lg" onClick={generatePDF}>
            <FaIcons.FaFileDownload /> Reporte
          </Button>
          &nbsp;&nbsp;
          {/* Botón para abrir el modal */}
          <Button color="secondary" size="lg" onClick={toggle}>
            <FaIcons.FaFileImport /> Importar Excel
          </Button>
        </div>
        <div className="frm containerInput">
          <Input
            className="form-control inputBuscar"
            bsSize="lg"
            value={busqueda}
            placeholder="Búsqueda por Email, tipo carrera, etc..."
            onChange={handleChangeB}
          />
          <Button className="btn btn-success" size="lg">
            <FaIcons.FaSearch /> Buscar
          </Button>
        </div>

        <Table className="frm" responsive="sm" id="tabl">
          <thead id="stahead">
            <tr className="text-center">
              <th>N°</th>
              <th>
                <span onClick={() => handleSortingChange("nombre")}>
                  Nombre:
                  {sortField === "nombre" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "nombre" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("apellido")}>
                  Apellido:
                  {sortField === "apellido" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "apellido" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("email")}>
                  Correo
                  {sortField === "email" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "email" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("tipcarr_sup_bec")}>
                  Tipo Carrera
                  {sortField === "tipcarr_sup_bec" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "tipcarr_sup_bec" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("anio_ing_bqef")}>
                  Año Ingreso
                  {sortField === "anio_ing_bqef" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "anio_ing_bqef" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("anio_egre_bqef")}>
                  Año Egreso
                  {sortField === "anio_egre_bqef" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "anio_egre_bqef" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("igle_nac_bec")}>
                  Iglesia
                  {sortField === "igle_nac_bec" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "igle_nac_bec" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("celular")}>
                  Celular
                  {sortField === "celular" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "celular" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("patro_bec")}>
                  Patrocinador
                  {sortField === "patro_bec" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "patro_bec" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((Usuario, index) => (
              <tr className="text-center" key={Usuario.id}>
                <td>{index + 1}</td>
                <td>{Usuario.nombre}</td>
                <td>{Usuario.apellido}</td>
                <td>{Usuario.email}</td>
                <td>{Usuario.tipcarr_sup_bec}</td>
                <td>{Usuario.anio_ing_bqef}</td>
                <td>{Usuario.anio_egre_bqef}</td>
                <td>{Usuario.igle_nac_bec}</td>
                {/* <td>{Usuario.jmen_bec}</td> */}
                <td>{Usuario.celular}</td>
                <td>{Usuario.patro_bec}</td>
                <td>
                  <button
                    className="btn btn-warning"
                    onClick={() => seleccionarUsuario(Usuario, "Editar")}
                  >
                    Editar
                  </button>{" "}
                  {"  "}
                  <button
                    className="btn btn-danger"
                    onClick={() => seleccionarUsuario(Usuario, "Eliminar")}
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {/* Modal añadir usuario */}
        <Modal isOpen={modalInsertar} toggle={abrirCerrarModalInsertar}>
          <ModalHeader className="header_mo">
            Insertar Becario Graduado
          </ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label>Nombre(s): </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="nombre"
                  value={usuarioSeleccionado.nombre}
                  onChange={handleChange}
                />
                {!isValid.nombre && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 100 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Apellido(s): </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="apellido"
                  value={usuarioSeleccionado.apellido}
                  onChange={handleChange}
                />
                {!isValid.apellido && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 100 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Correo: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="email"
                  value={usuarioSeleccionado.email}
                  onChange={handleChange}
                />
                {!isValid.email && (
                  <span style={{ color: "red" }}>Correo no válido</span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Carrera: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="carr_sup_bec"
                  value={usuarioSeleccionado.carr_sup_bec}
                  onChange={handleChange}
                />
                {!isValid.carr_sup_bec && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 150 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Institución Superior: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="inst_sup_bec"
                  value={usuarioSeleccionado.inst_sup_bec}
                  onChange={handleChange}
                />
                {!isValid.inst_sup_bec && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 150 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Tipo Carrera: </Label>
                <Input
                  type="select"
                  className="form-control"
                  name="tipcarr_sup_bec"
                  value={usuarioSeleccionado.tipcarr_sup_bec}
                  onChange={handleChange}
                >
                  <option value="">Seleccione una opción</option>
                  <option value="Licenciatura">Licenciatura</option>
                  <option value="Técnico Superior">Técnico Superior</option>
                  <option value="Técnico Medio">Técnico Medio</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Año Ingreso: </Label>
                <Input
                  type="select"
                  className="form-control"
                  name="anio_ing_bqef"
                  value={usuarioSeleccionado.anio_ing_bqef}
                  onChange={handleChange}
                >
                  <option value="">Seleccione un año</option>
                  <option value="2020">2020</option>
                  <option value="2021">2021</option>
                  <option value="2022">2022</option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                  <option value="2027">2027</option>
                  <option value="2028">2028</option>
                  <option value="2029">2029</option>
                  <option value="2030">2030</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Año Egreso: </Label>
                <Input
                  type="select"
                  className="form-control"
                  name="anio_egre_bqef"
                  value={usuarioSeleccionado.anio_egre_bqef}
                  onChange={handleChange}
                >
                  <option value="">Seleccione un año</option>
                  <option value="2020">2020</option>
                  <option value="2021">2021</option>
                  <option value="2022">2022</option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                  <option value="2027">2027</option>
                  <option value="2028">2028</option>
                  <option value="2029">2029</option>
                  <option value="2030">2030</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Iglesia: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="igle_nac_bec"
                  value={usuarioSeleccionado.igle_nac_bec}
                  onChange={handleChange}
                />
                {!isValid.igle_nac_bec && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 100 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Junta Mensual: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="jmen_bec"
                  value={usuarioSeleccionado.jmen_bec}
                  onChange={handleChange}
                />
                {!isValid.jmen_bec && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 100 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Celular: </Label>
                <Input
                  type="number"
                  className="form-control"
                  name="celular"
                  value={usuarioSeleccionado.celular}
                  onChange={handleChange}
                />
                {!isValid.celular && (
                  <span style={{ color: "red" }}>Número celular no válido</span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Patrocinador: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="patro_bec"
                  value={usuarioSeleccionado.patro_bec}
                  onChange={handleChange}
                />
                {!isValid.patro_bec && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 100 letras y espacios
                  </span>
                )}
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={(e) => peticionPost(e)}
              disabled={
                !isValid.nombre ||
                !isValid.apellido ||
                !isValid.email ||
                !isValid.igle_nac_bec ||
                !isValid.jmen_bec ||
                !isValid.celular ||
                !isValid.patro_bec
              }
            >
              Guardar
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalInsertar()}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal Editar */}
        <Modal isOpen={modalEditar} toggle={abrirCerrarModalEditar}>
          <ModalHeader className="header_mo">Editar Usuario</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label>Nombre(s): </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="nombre"
                  value={usuarioSeleccionado && usuarioSeleccionado.nombre}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Apellido(s): </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="apellido"
                  value={usuarioSeleccionado && usuarioSeleccionado.apellido}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Correo: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="email"
                  value={usuarioSeleccionado && usuarioSeleccionado.email}
                  onChange={handleChange}
                  disabled
                />
              </FormGroup>
              <FormGroup>
                <Label>Carrera: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="carr_sup_bec"
                  value={
                    usuarioSeleccionado && usuarioSeleccionado.carr_sup_bec
                  }
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Institución Superior: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="inst_sup_bec"
                  value={
                    usuarioSeleccionado && usuarioSeleccionado.inst_sup_bec
                  }
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Tipo Carrera: </Label>
                <Input
                  type="select"
                  className="form-control"
                  name="tipcarr_sup_bec"
                  value={
                    usuarioSeleccionado && usuarioSeleccionado.tipcarr_sup_bec
                  }
                  onChange={handleChange}
                >
                  <option value="">Seleccione una opción</option>
                  <option value="Licenciatura">Licenciatura</option>
                  <option value="Técnico Superior">Técnico Superior</option>
                  <option value="Técnico Medio">Técnico Medio</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Año Ingreso: </Label>
                <Input
                  type="select"
                  className="form-control"
                  name="anio_ing_bqef"
                  value={
                    usuarioSeleccionado && usuarioSeleccionado.anio_ing_bqef
                  }
                  onChange={handleChange}
                >
                  <option value="">Seleccione un año</option>
                  <option value="2020">2020</option>
                  <option value="2021">2021</option>
                  <option value="2022">2022</option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                  <option value="2027">2027</option>
                  <option value="2028">2028</option>
                  <option value="2029">2029</option>
                  <option value="2030">2030</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Año Egreso: </Label>
                <Input
                  type="select"
                  className="form-control"
                  name="anio_egre_bqef"
                  value={
                    usuarioSeleccionado && usuarioSeleccionado.anio_egre_bqef
                  }
                  onChange={handleChange}
                >
                  <option value="">Seleccione un año</option>
                  <option value="2020">2020</option>
                  <option value="2021">2021</option>
                  <option value="2022">2022</option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                  <option value="2027">2027</option>
                  <option value="2028">2028</option>
                  <option value="2029">2029</option>
                  <option value="2030">2030</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Iglesia: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="igle_nac_bec"
                  value={
                    usuarioSeleccionado && usuarioSeleccionado.igle_nac_bec
                  }
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Junta Mensual: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="jmen_bec"
                  value={usuarioSeleccionado && usuarioSeleccionado.jmen_bec}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Celular: </Label>
                <Input
                  type="number"
                  className="form-control"
                  name="celular"
                  value={usuarioSeleccionado && usuarioSeleccionado.celular}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Patrocinador: </Label>
                <Input
                  type="text"
                  className="form-control"
                  name="patro_bec"
                  value={usuarioSeleccionado && usuarioSeleccionado.patro_bec}
                  onChange={handleChange}
                />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="success" size="lg" onClick={() => peticionPut()}>
              Modificar
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalEditar()}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modalEliminar} toggle={abrirCerrarModalEliminar}>
          <ModalHeader className="header_mo">Eliminar Patrocinador</ModalHeader>
          <ModalBody>
            ¿Estás seguro que deseas eliminar el Graduado{" "}
            {usuarioSeleccionado && usuarioSeleccionado.nombre}{" "}
            {usuarioSeleccionado && usuarioSeleccionado.apellido}?
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={() => peticionDelete(usuarioSeleccionado.email)}
            >
              Sí
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalEliminar()}
            >
              No
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal Importar */}
        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader className="header_mo">
            Importar Archivo Excel
          </ModalHeader>
          <ModalBody>
            <Form>
              <Input
                type="file"
                accept=".xls,.xlsx,.csv"
                onChange={handleFileChange}
              />
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="success" size="lg" onClick={handleImport}>
              Importar
            </Button>{" "}
            <Button color="danger" size="lg" onClick={toggle}>
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

export default ListUserGrad;
